import { render, staticRenderFns } from "./product-builder-main.vue?vue&type=template&id=a210963c&"
import script from "./product-builder-main.vue?vue&type=script&lang=js&"
export * from "./product-builder-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports